import {noop} from '@benchling/js-utils';
import React from 'react';

import {Owner} from 'auth/PermissionConstants';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import InputWrapper from 'ui-library/inputs/InputWrapper';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import uniqueId from 'util/uniqueId';

export interface SchemaOwnerDropdownProps {
  className?: string;
  ownerChoices: Array<Owner>;
  owner: Owner | null | undefined;
  onOwnerChanged: (owner: Owner) => void;
  isRequired?: boolean;
  dataTestAttrs?: DataTestAttrs;
  ownerLabel?: string;
  noChoicesMessage?: string;
}

/**
 * SchemaOwnerDropdown is an owner dropdown for schema pages with updated styling and
 * should be favored over OwnerDropdown. It is not specific to assay schemas.
 */
export default function SchemaOwnerDropdown(props: SchemaOwnerDropdownProps): JSX.Element {
  return (
    <InputWrapper
      id={uniqueId('ownerName')}
      label={props.ownerLabel ?? 'Owner'}
      labelStyle={FieldLabel.STYLES.LABEL}
      isRequired={props.isRequired ?? true}
    >
      <SelectDropdown
        className={props.className}
        displayName={props.owner ? props.owner.name : ''}
        menu={
          <Menu
            value={props.owner ? props.owner.handle : null}
            height={Menu.HEIGHTS.MEDIUM}
            width={Menu.WIDTHS.FULL}
            scrollable={true}
          >
            {props.ownerChoices.length > 0
              ? props.ownerChoices.map((owner) => (
                  <Option
                    key={owner.handle}
                    value={owner.handle}
                    onSelect={() => {
                      props.onOwnerChanged(owner);
                    }}
                  >
                    {owner.name}
                  </Option>
                ))
              : props.noChoicesMessage && (
                  <Option isDisabled={true} value={null} onSelect={noop}>
                    {props.noChoicesMessage}
                  </Option>
                )}
          </Menu>
        }
        dataTestAttrs={props.dataTestAttrs}
      />
    </InputWrapper>
  );
}
